export default { sha: 'f939e16304fe5548d2141b7d10cab556c2564280', buildNumber: 'undefined' }
